<div class="checkin__header" [ngClass]="{ 'guest__area__header--responsive' : layout?.header?.responsive }">
  <a [href]="webDomain">
    <img
      *ngIf="logo?.height && logo?.width"
      [src]="logo?.url"
      class="logo"
      [ngStyle]="{
        'height' : logo?.height,
        'width' : logo?.width
      }" />
  </a>
  <div class="checkin__header__selectors">
    <app-input-language *ngIf="layout?.language?.show"></app-input-language>
    <app-input-currency *ngIf="layout?.currency?.show"></app-input-currency>
  </div>
</div>
